require('/ui/components/entitypicker/itemlist/itemlist.module.scss.module.css');

export const uepItem = "_uep-item_jkgip_1";
